import styled from 'styled-components'

export const HeroVideoStyled = styled.video<{ $isExpandable?: boolean }>`
  display: block;
  width: 100%;
  height: auto;
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};
  cursor: ${({ $isExpandable }) => ($isExpandable ? 'zoom-in' : 'auto')};
`
